import { ChecklistLine } from '@core/models';

export interface LinkResult {
  installationOid: string;
  boundCount: number;
  // Whether a checklist line still has a channel the user can choose.
  hasChoice: boolean;
}

interface LinkDetail {
  installation_oid?: string;
  checklist?: Partial<ChecklistLine>[];
}

interface LinkResponse extends LinkDetail {
  details?: LinkDetail[];
}

// The provision act answers with the installation the device joined and the checklist customer-func
// derived for it, in the first of its details; the route that links a registered device answers
// with the same two at the top level. Only the lines that now read from the linked device count as
// bound by the link: the checklist lists required points only, and a line bound to another meter
// was bound before.
export function linkResult(response: unknown, deviceId: string | number): LinkResult | null {
  const body = response as LinkResponse | null;
  const detail = body?.details?.[0] ?? body;
  if (!detail?.installation_oid) return null;
  const device = Number(deviceId);
  const lines = detail.checklist ?? [];
  return {
    installationOid: detail.installation_oid,
    boundCount: lines.filter(line => line.state === 'bound' && line.source?.deviceId === device)
      .length,
    hasChoice: lines.some(line => (line.candidates?.length ?? 0) > 0),
  };
}

export function linkResultMessage(result: LinkResult): { key: string; params: { count: number } } {
  const params = { count: result.boundCount };
  if (result.boundCount === 0) {
    const key = result.hasChoice ? 'installations.link.noneBound' : 'installations.link.noneFit';
    return { key, params };
  }
  return {
    key: result.boundCount === 1 ? 'installations.link.boundOne' : 'installations.link.bound',
    params,
  };
}
